import React from "react";
import "./loader.css";

export const Loader = () => {
  return (
    <div className="loader-page">
      <div className="loader"></div>
      <div className="loader-text">
        Loading PDF <br /> Please wait..
      </div>
    </div>
  );
};
